import styled from 'styled-components';
import { screen, spacing } from 'theme';

export const StyledShareModalButtons = styled.div`
  display: flex;
  margin-bottom: ${spacing('xl')};

  > *:not(:last-child) {
    margin-right: ${spacing('lg')};
  }

  @media (max-width: ${screen('mdMax')}) {
    flex-wrap: wrap;
    > * {
      width: 2.5rem;
      height: 2.5rem;

      svg {
        width: ${spacing('lg')};
        height: ${spacing('lg')};
      }

      &:not(:last-child) {
        margin-right: ${spacing('md')};
      }
    }
  }
`;

export const StyledCopyAnchor = styled.span`
  display: inline-block;
`;

export const StyledCopyWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding-right: 2rem;
  line-height: 0;
`;
